export default function TextTableDirective() {
  return {
    template: require('./text-table.component.html'),
    transclude: true,
    restrict: 'AE',
    scope: {
      values: '=',
      submitted: '=?',
      form: '=',
      onSave: '=',
    },
    controllerAs: 'vm',
    bindToController: true,
    controller: TextTableComponentController,
  };

  function TextTableComponentController($scope) {
    'ngInject';
    let vm = this;

    vm.currentPage = 1;
    vm.maxTextLength = 255;
    vm.valField = false;
    vm.maxSize = 3;
    vm.itemsPerPage = 10;

    vm.newVal = {
      value: '',
      attrs: {},
    };

    vm.addFailed = false;
    vm.valueExists = valueExists;
    vm.textValid = textValid;
    vm.validRow = validRow;
    vm.addVal = addVal;
    vm.getListIndex = getListIndex;
    vm.keydown = keydown;
    vm.rowErrorCount = rowErrorCount;

    vm.$onInit = () => {
      vm.submitted = vm.form.$submitted;
      if (!vm.onSave.invoke) {
        vm.onSave.invoke = () => {};
      }
    };

    $scope.$watch(
      function () {
        return vm.values;
      },
      function () {
        vm.form.newTextValue.$setValidity('required', !vm.values || vm.values.length > 0);
      },
      true,
    );

    function textValid() {
      return vm.values && vm.values.length > 0;
    }

    function validRow(val) {
      return val && val.length > 0;
    }

    function addVal(value) {
      if (!value || !value.value || value.value.length === 0 || vm.valueExists()) {
        vm.addFailed = true;
        return;
      }
      vm.values.push(JSON.parse(JSON.stringify(value)));
      vm.newVal.value = '';
      vm.addFailed = false;

      GTM_ListChanged('attributeTextValueAdded');
    }

    function getListIndex(pageIndex) {
      return pageIndex + (vm.currentPage - 1) * vm.itemsPerPage;
    }

    function keydown() {
      let keyCode = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
      if (keyCode === 13) {
        let e = window.event;

        e.cancelBubble = true;
        e.returnValue = false;

        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
          if (vm.valField) {
            vm.addVal(vm.newVal);
          }
        }
      }
    }

    function rowErrorCount() {
      let errorCount = 0;
      if (vm.form.$error.required) {
        for (let i = 0; i < vm.form.$error.required.length; i++) {
          let error = vm.form.$error.required[i];
          if (error.$name === 'textForm') {
            errorCount = errorCount + 1;
          }
        }
      }
      return errorCount;
    }

    function valueExists() {
      if (vm.newVal.value) {
        for (let i = 0; i < vm.values.length; i++) {
          if (
            vm.values[i].value &&
            vm.values[i].value.toLocaleLowerCase() === vm.newVal.value.toLocaleLowerCase()
          ) {
            return true;
          }
        }
      }
      return false;
    }

    vm.pageChanged = function () {
      GTM_ListChanged('attributeTextPageChanged');
    };

    function GTM_ListChanged(event) {
      window.dataLayer.push({
        event: event,
        data: {
          total: vm.values.length,
          pageNumber: vm.currentPage,
        },
      });
    }
  }
}
